module.exports = __webpack_public_path__ + "static/media/wB.b99f3830.svg";